import axios from 'axios';
const state = {
    authenticated: false,
    vehicleRegistered: false,
    error: false,
    errorMessage: '',
    errors: null,
    hasAccount: false,
    vehicleAdded: false
};

const getters = {

};

const actions = {
    async checkAuthenticated({ commit }) {
        try {
            const response = await axios.get('/api/auth-status')
            commit('setAuthenticated', response.data.authenticated)
        } catch (error) {
            console.error(error);
            reject(error);
        }
    },
    async registeredVehicle({ commit }, { vehicleReg }) {
        try {
            const response = await axios.get(`/api/check-vehicle/${vehicleReg}`)
            commit('setVehicleRegistered', response.data.registered)
        } catch (error) {
            console.error(error);
            reject(error);
        }
    },
    async login({ commit, dispatch }, { email, password }) {
        try {
            const response = await axios.post('/login', { email, password })
            commit('setErrors', null)
            dispatch('CustomerData/storeCustomerData', response.data.user, { root: true });
            dispatch('checkAuthenticated');
            const userName = response.data.user.firstName;
            const myAccountSpan = document.getElementById('header-menu__my-account');
            if (myAccountSpan) {
                myAccountSpan.textContent = userName;
            }
        } catch (error) {
            const errors = error.response.data.errors;
            console.error(error.response.data.errors)
            const flattenedErrors = [].concat(...Object.values(errors));
            console.error(flattenedErrors)
            commit('setErrors', flattenedErrors)
        }
    },
    async resetPassword({ commit }, { email, password }) {
        try {
            const response = await axios.post('/password/email', { email })
            commit('setErrors', null)
            commit('setStatusMessage', 'We have emailed your password reset link.');
        } catch (error) {
            const errors = error.response.data.errors;
            console.error(error.response.data.errors)
            const flattenedErrors = [].concat(...Object.values(errors));

            commit('setErrors', flattenedErrors)
            commit('setStatusMessage', null);
        }
    },
};
const mutations = {
    setAuthenticated(state, authenticated) {
        state.authenticated = authenticated;
    },
    setVehicleRegistered(state, vehicleRegistered) {
        state.vehicleRegistered = vehicleRegistered;
    },
    setErrors(state, error) {
        state.errors = error
    },
    setHasAccount(state, hasAccount) {
        state.hasAccount = hasAccount;
    },
    setVehicleAdded(state, vehicleAdded) {
        state.vehicleAdded = vehicleAdded;
    },
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

